module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-dialog', {
    attrs: {
      "title": "日活用户",
      "visible": _vm.dialogVisible,
      "width": "80%",
      "custom-class": "dialog",
      "footer": false
    },
    on: {
      "close": _vm.handleClose
    }
  }, [_c('Account')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7a5303fe"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/administrator/common/modal.vue
// module id = 1813
// module chunks = 9